export default __webpack_public_path__ + "static/media/discount_single.996e79cf.png";